:host {
  display: block;
  width: 100%;
  height: 100%;

  @mixin fade-in($time: 1) {
    animation: imageFadeIn  #{$time}s ease-in 0s 1 forwards;
    @keyframes imageFadeIn {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
  }

  @mixin fade-out($time: 1) {
    animation: imageFadeOut  #{$time}s ease-in 0s 1 forwards;
    @keyframes imageFadeOut {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }
  }

  img {
    opacity: 1;

    &.fade-in {
      @include fade-in(0.6);
    }

    &.fade-out {
    @include fade-out(0.6);

      z-index: -1;
    }
  }
}
